/**
 * Claves de caché de TanStack Query reconciliadas (INC-09 / CA-F7).
 *
 * - `available-advances`: saldos disponibles del proveedor (lo que el modal busca).
 * - `advance-applications`: aplicaciones ya aplicadas al documento (lo que el panel renderiza).
 *
 * No confundir ambas: son dos dominios distintos con dos claves distintas (R7).
 */

export const availableAdvancesQueryKey = (documentId: string) =>
  ['available-advances', documentId] as const;

export const advanceApplicationsQueryKey = (documentId: string) =>
  ['advance-applications', documentId] as const;
